import { useSelector } from 'react-redux';
import { getEnvironment } from 'store/general';

export const useEnvironment = () => {
  const { data } = useSelector(getEnvironment);

  return data;
};
